









import Vue from 'vue';
import Component from 'vue-class-component';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';

@Component({
    name: 'portal-message',
})
export default class PortalMessage extends Vue {
    show: boolean = false;
    timeout: number = 5000;
    message: string = '';
    color: string = '';
    showButton: boolean = true;

    mounted() {
        EventBus.$on(EventBusMessages.SHOW_ERROR, (message: string) => {
            this.color = 'error';
            this.message = message;
            this.show = true;
            this.showButton = true;
            this.timeout = 5000;
        });

        EventBus.$on(EventBusMessages.SHOW_SUCCESS, (message: string) => {
            this.color = 'success';
            this.message = message;
            this.show = true;
            this.showButton = true;
            this.timeout = 5000;
        });

        EventBus.$on(EventBusMessages.SHOW_INFO, (message: string) => {
            this.color = 'success';
            this.message = message;
            this.show = true;
            this.showButton = false;
            this.timeout = 15000;
        });
    }
}
